import { PrincipalDto } from './../../../../../packages/core/src/models/dto/Users/principal.dto';
import { ClassroomDto, Config, ClassroomGroupDto } from '@ecdlink/core';
import { ClassroomInput } from '@ecdlink/graphql';
import { api } from '../axios.helper';
import { inputObjectToCamelCase } from '@/utils/object-utils';
class ClassroomService {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async getClassrooms(): Promise<ClassroomDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: `allClassroomsV2`,
    });

    if (response.status !== 200) {
      throw new Error('Get Classrooms Failed - Server connection error');
    }

    return response.data.data.allClassroomsV2;
  }

  async updateClassroom(id: string, input: ClassroomInput): Promise<boolean> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'updateClassroom',
      variables: {
        id: id,
        input: input,
      },
    });

    if (response.status !== 200) {
      throw new Error('Updating classroom failed - Server connection error');
    }

    return true;
  }

  async updateClassroomSiteAddress(
    id: string,
    input: ClassroomInput
  ): Promise<boolean> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'updateClassroomSiteAddress',
      variables: {
        id: id,
        input: inputObjectToCamelCase(input),
      },
    });

    if (response.status !== 200) {
      throw new Error(
        'Updating classroom site address failed - Server connection error'
      );
    }

    return response.data.data.updateClassroomSiteAddress;
  }
  async getAllClassroomForCoach(userId: string): Promise<ClassroomDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);

    const response = await apiInstance.post<any>(``, {
      id: `allClassroomsV2`,
    });

    if (response.status !== 200) {
      throw new Error(
        'Get Practitioners For Coach Failed - Server connection error'
      );
    }

    return response.data.data.allClassroomsForCoach;
  }

  async getClassroomGroupClassroomsForPractitioner(
    userId: string
  ): Promise<ClassroomDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);

    const response = await apiInstance.post<any>(``, {
      id: `classroomGroupClassroomsForPractitioner`,
      variables: {
        userId,
      },
    });

    if (response.status !== 200) {
      throw new Error('Get Classroom Failed - Server connection error');
    }

    return response.data.data.classroomGroupClassroomsForPractitioner;
  }

  async getClassroomsForPractitioner(
    practitionerId: string,
    principalId: string
  ): Promise<{
    classroom: ClassroomDto;
    principal: PrincipalDto;
    classroomGroups: ClassroomGroupDto[];
  }> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);

    const response = await apiInstance.post<any>(``, {
      id: `GetClassroomForPractitioner`,
      variables: {
        practitionerId,
        principalId,
      },
    });

    if (response.status !== 200) {
      throw new Error(
        'Get Practitioners For Coach Failed - Server connection error'
      );
    }

    return response.data.data.allClassroomsForPractitioner;
  }

  async updatePreschoolFee(
    classroomId: string,
    amount: number | undefined
  ): Promise<boolean> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'updatePreschoolFeeForClassroom',
      variables: {
        classroomId: classroomId,
        amount: amount,
      },
    });

    if (response.status !== 200 || !!response.data.error) {
      throw new Error(
        'Updating preschool fee failed - Server connection error'
      );
    }

    return response.data.data.updatePreschoolFeeForClassroom;
  }
}

export default ClassroomService;
